import type { ConversationFlag } from '@/api/types';

/** The most feedback one flag takes, as the server enforces it. */
export const FEEDBACK_MAX = 4000;

const MESSAGE_ANCHOR_PREFIX = 'message-';

/** The id a message's row carries in its conversation, so a link can land on it. */
export function messageAnchorId(messageId: string): string {
  return `${MESSAGE_ANCHOR_PREFIX}${messageId}`;
}

/** The message a location's hash points at (`#message-<id>`), or '' when it points at none. */
export function anchoredMessageId(hash: string): string {
  const prefix = `#${MESSAGE_ANCHOR_PREFIX}`;
  return hash.startsWith(prefix) ? hash.slice(prefix.length) : '';
}

/** Where a flag is read in context: its conversation, at the flagged message when there is one. */
export function conversationFlagHref(flag: ConversationFlag): string {
  const conversation = `/conversations/${flag.conversationId}`;
  return flag.messageId ? `${conversation}#${messageAnchorId(flag.messageId)}` : conversation;
}
